import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "../../layout/app/dashboard/dashboard";
import Layouts from "../../layout/app/dashboard/layouts";
import MainLayout from "../../layout/app/dashboard/mainLayout";
import CompanyInfo from "../../layout/app/pages/admin/companyInfo/companyInfo";
import Outlets from "../../layout/app/pages/admin/outlet/outlets";
import Users from "../../layout/app/pages/admin/users/users";
import Purchase from "../../layout/app/pages/billing/purchase/purchase";
import AccountMaster from "../../layout/app/pages/master/accounts/accountMaster";
import Customers from "../../layout/app/pages/master/customer/customers";
import Head from "../../layout/app/pages/master/head/head";
import MainCategory from "../../layout/app/pages/master/mainCategory/mainCategory";
import MainMenu from "../../layout/app/pages/master/mainMenu/mainMenu";
import MenuAuthorization from "../../layout/app/pages/master/menuAuthorization/menuAuthorization";
import Product from "../../layout/app/pages/master/products/product";
import SalesMan from "../../layout/app/pages/master/salesman/salesMan";
import SubCategory from "../../layout/app/pages/master/subCategory/subCategory";
import SubMenu from "../../layout/app/pages/master/subMenu/subMenu";
import TypeDesign from "../../layout/app/pages/master/typedesign/typeDesign";
import Uom from "../../layout/app/pages/master/uom/uom";
import WareHouse from "../../layout/app/pages/master/warehouse/wareHouse";
import SideNav from "../../layout/app/sideNav/sideNav";
import Login from "../../layout/screen/login";
import PageNotFound from "../utils/errorPage/pageNotFound";
import IsAuth, { IsLoggedIn, ProtectedRoute } from "./auth";
import Roles from "../../layout/app/pages/admin/roles/roles";
import PurchaseReturn from "../../layout/app/pages/billing/purchaseReturn/purchaseReturn";
import SalesOrIssue from "../../layout/app/pages/billing/salesOrIssue/salesOrIssue";
import SalesReturn from "../../layout/app/pages/billing/salesReturn/salesReturn";
import Wastage from "../../layout/app/pages/billing/wastage/wastage";
import Receipts from "../../layout/app/pages/billing/receipts/receipts";
import Payment from "../../layout/app/pages/billing/payment/Payment";
import PurchaseQR from "../../layout/app/pages/billing/purchaseQR/purchaseQR";
import CloseStock from "../../layout/app/pages/billing/closeStock/closeStock";
import BarCode from "../../layout/app/pages/billing/barCode/barCode";
import Expenses from "../../layout/app/pages/billing/expenses/expenses";
import Sales from "../../layout/app/pages/outlets/sales/sales";
import Wastages from "../../layout/app/pages/outlets/wastages/wastages";
import CloseStocks from "../../layout/app/pages/outlets/closeStocks/closeStocks";
import Expense from "../../layout/app/pages/outlets/expense/dummy";
import SalesReturns from "../../layout/app/pages/outlets/salesReturns/salesReturns";
import Products from "../../layout/app/pages/reports/products/products";
import SalesReport from "../../layout/app/pages/reports/sales/salesReport";
import SalesReturnReport from "../../layout/app/pages/reports/salesReturn/salesReturnReport";
import ItemReport from "../../layout/app/pages/reports/itemwise/itemReport";
import GstReport from "../../layout/app/pages/reports/gst/gstReport";
import PurchaseReport from "../../layout/app/pages/reports/purchase/purchaseReport";
import PurchaseReturnReport from "../../layout/app/pages/reports/purchaseReturn/purchaseReturnReport";
import PaymentReports from "../../layout/app/pages/reports/payment/paymentReports";
import ReceiptReports from "../../layout/app/pages/reports/receipts/receiptReports";
import SalesManReport from "../../layout/app/pages/reports/salesman/salesManReport";
import SalesLedger from "../../layout/app/pages/reports/ledger/salesLedger/salesLedger";
import PurchaseLedger from "../../layout/app/pages/reports/ledger/purchaseLedger/purchaseLedger";
import StockLedger from "../../layout/app/pages/reports/ledger/stockLedger/stockLedger";
import HsnReport from "../../layout/app/pages/reports/gst/hsnReport";
import ExpensesReport from "../../layout/app/pages/reports/expenses/expensesReport";
import ExpensesLedger from "../../layout/app/pages/reports/ledger/expensesLedger/expensesLedger";
import OutletExpenses from "../../layout/app/pages/reports/outletExpenses/outletExpenses";
import Invoice from "../utils/invoicePage/invoice";
import ThermalPrint from "../utils/invoicePage/thermalPrint";
import OutletSalesReport from "../../layout/app/pages/reports/outletsales/outletSalesReport";
import OutletItemReport from "../../layout/app/pages/reports/outletSalesItemwise/outletItemReport";
import OutletItemBreakupsReport from "../../layout/app/pages/reports/outletItemwiseBreakups/outletItemBreakupsReport";
import OutletSalesLedger from "../../layout/app/pages/reports/ledger/outletSalesLedger/OutletSalesLedger";
import OutletGstReport from "../../layout/app/pages/reports/outletGst/outletGstReport";
import OutletHsnReport from "../../layout/app/pages/reports/outletHsn/outletHsnReport";
import OutletStockLedger from "../../layout/app/pages/reports/ledger/outletStockLedger/outletStockLedger";
import StockVerify from "../../layout/app/pages/outlets/stockVerify/stockVerify";
import Loyality from "../../layout/app/pages/master/loyality/loyality";
import WhAllItemWise from "../../layout/app/pages/reports/whAllItemWise/whAllItemWise";
import WhGroupWise from "../../layout/app/pages/reports/whGroupWise/whGroupWise";
import OtAllItemWise from "../../layout/app/pages/reports/otAllItemWise/otAllItemWise";
import OtGroupWise from "../../layout/app/pages/reports/otAllGroupWise/otGroupWise";
import AllOutletStockLedger from "../../layout/app/pages/reports/ledger/allOutletStockLedger/allOutletsStockLedger";
import OtExpensesLedger from "../../layout/app/pages/reports/ledger/outletExpenseLedger/otExpensesLedger";
import Wrong from "../utils/errorPage/wrong";
import AllSalesManReport from "../../layout/app/pages/reports/allSalemanReport/allSalesManReport";
import ProductPdf from "../utils/invoicePage/productPdf";
import InvoiceReport from "../utils/invoicePage/invoiceReport";
import StockMissingReports from "../../layout/app/pages/reports/stockMissingReports/stockMissingReports";
import OtSalesReturn from "../../layout/app/pages/reports/otSalesReturnReport/otSalesReturn";
import OtPurchaseReturn from "../../layout/app/pages/reports/otPurchaseReturnReport/otPurchaseReturn";
import CashClose from "../../layout/app/pages/master/cashClose/cashClose";
import OtCashClose from "../../layout/app/pages/reports/otCashClose/otCashClose";
import NotVisibleScreen from "../../layout/app/dashboard/notVisibleScreen";
import ExpensesClose from "../../layout/app/pages/outlets/expensesClose/expensesClose";
import OtExpenseClose from "../../layout/app/pages/reports/otExpenseClose/otExpenseClose";
import CashCloseThemal from "../utils/invoicePage/cashCloseThemal";
import ExpenseCloseThermal from "../utils/invoicePage/expenseCloseThermal";
import BarcodeEntry from "../../layout/app/pages/billing/barcodeEntry/barcodeEntry";
import WalletTransfer from "../../layout/app/pages/admin/walletTransfer/walletTransfer";
import SubAccountMaster from "../../layout/app/pages/master/subAccounts/subAccountsMaster";
import OtToOtTransfer from "../../layout/app/pages/outlets/otTootTransfer/otToOtTransfer";
import OtTootTransferReports from "../../layout/app/pages/reports/otToOtTransfer/otTootTransferReports";
import PaymentType from "../../layout/app/pages/master/paymentType/paymentType";
import MemberReports from "../../layout/app/pages/reports/memberReports/memberReports";
import ClosingStockExpense from "../../layout/app/pages/outlets/closeStocks/closingStockExpense";
import PhonePayLogs from "../../layout/app/pages/outlets/phonePayLogs/phonePayLogs";
import PhonePayEnquiry from "../../layout/app/pages/outlets/phonePayEnquiry/phonePayEnquiry";
import BillWiseHsn from "../../layout/app/pages/reports/billWiseHsn/billWiseHsn";
import WhCashClose from "../../layout/app/pages/billing/whCashClose/whCashClose";
import DummyWh from "../../layout/app/pages/billing/expenses/dummyWh";
import OtClosingStockReports from "../../layout/app/pages/reports/otClocingStockReport/otClosingStockReports";
import SalestransferReport from "../../layout/app/pages/reports/salestransferReport/salestransferReport";
import OtClosingStockMissingReports from "../../layout/app/pages/reports/otClosingmissingStockReport/otclosingmissingstockReports";
import BarcodeHistory from "../../layout/app/pages/reports/barcodeHistory/barcodehistory";
import BarcodeAuditHistory from "../../layout/app/pages/reports/barcodeAuditHistory/barcodeAuditHistory";
import ProductGrnReport from "../../layout/app/pages/reports/productGrnReport/productGrnReport";
import OutletSalesManReport from "../../layout/app/pages/reports/salesman/outletSalesManReport";
import BarcodeDiscount from "../../layout/app/pages/billing/barcodediscount/barcodediscount";
import OverallBranchWiseReport from "../../layout/app/pages/reports/overallBranchwiseReport/overallBranchWiseReport";
import BranchWisePhysicalStockReport from "../../layout/app/pages/reports/branchWisePhysicalReport/branchWsiePhysicalStockReport";
import TransferRequest from "../../layout/app/pages/billing/transferRequest/transferRequest";
import StockValueReport from "../../layout/app/pages/reports/stockvalueReport/stockValueReport";
import WarehouseTransferReport from "../../layout/app/pages/billing/warehousetransferReport/warehouseTransferReport";
import WhExpensesClose from "../../layout/app/pages/billing/whexpensesClose/whExpensesClose";
import WhExpenseCloseReport from "../../layout/app/pages/reports/warehouseExpensecloseReport/whExpenseCloseReport";
import Invoices from "../utils/invoicePage/invoices";
import MemberList from "../../layout/app/pages/master/members/members";
import Whdamageapproval from "../../layout/app/pages/billing/wh approval/whdamageapproval";
import CustomerWiseSalesReport from "../../layout/app/pages/reports/customersalesReport/customerSalesReport";
import WhWalletTransfer from "../../layout/app/pages/outlets/whWallettransfer/whwalletTransfer";
import WhWalletReport from "../../layout/app/pages/reports/whWalletTransferReport/whWalletReport";
import WalletReport from "../../layout/app/pages/reports/otWallettransferReport/WalletReport";
import TransferPdf from "../utils/invoicePage/transferPdf";
import OutletReorderReport from "../../layout/app/pages/reports/reOrderReport/outletReorderReport";
import WhClosingStockReports from "../../layout/app/pages/reports/whClocingStockReport/whClosingStockReports";
import WhClosingStockMissingReports from "../../layout/app/pages/reports/whClosingmissingStockReport/whclosingmissingstockReports";
import SalesReorder from "../../layout/app/pages/billing/salesreorder/salesreorder";
import IndentReorderReport from "../../layout/app/pages/reports/indentReport/indentReorderReport";
import IndentSupplierReport from "../../layout/app/pages/reports/indentsupplier/indentSupplierReport";
import PurchaseReturns from "../../layout/app/pages/billing/purchasereturns/purchaseReturns";
import PurchaseReturnApprovel from "../../layout/app/pages/billing/purchasereturnApproval/purchasereturnapproval";
import OutletunsavedReport from "../../layout/app/pages/reports/unsavedReport/outletunsavedReport";
import OutletStockUnverified from "../../layout/app/pages/reports/unverified/outletunverfied";
import CloseStockWhPending from "../../layout/app/pages/billing/closingstockwhpending/closeStockWhpending";
import CloseStockOtPending from "../../layout/app/pages/billing/closingstockOtpending/closeStockOtpending";
import Salesperformance from "../../layout/app/pages/reports/salesperformance/salesperformance";
import Whdamagereport from "../../layout/app/pages/reports/WHClosingStockDamgeReport/whdamagereport";
import CustomerWalkInsReport from "../../layout/app/pages/reports/CustomerWalkInsReport/cutomerwalkins";
import BarcodeForm from "../../layout/app/pages/reports/otbarcodeHistory/otbarcodehistory";
import OtBranchCategoryWise from "../../layout/app/pages/reports/branch&categorywisesalesreport/BranchCategoryWiseSalesReport";
import StockVerifiactionBarcode from "../../layout/app/pages/outlets/stockVerificationBarcode/stockverificationbarcode";
import ReferrerReport from "../../layout/app/pages/reports/referrerReport/referrerReport";
import Stockverificationmismatchreport from "../../layout/app/pages/reports/stockverificationmismatchreport/stockverificationmismatchreport";
import Stockverifypendingreport from "../../layout/app/pages/reports/stockverifypendingreport/stockverifypendingreport";
import HighSalesVendorReport from "../../layout/app/pages/reports/highsalesvendorreport/highsalesvendorreport";
import NetProfitSalesReport from "../../layout/app/pages/reports/netProfitSalesReport/netProfitSalesReport";
import TransactionProvider from "../../layout/app/pages/admin/transactionprovider/transactionprovider";
const Routers = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layouts />} />
        <Route path="/noScreen" element={<NotVisibleScreen />} />

        {/* <Route path="/login" element={token ? <Navigate to='/dashboard'/> : <Login />}/> */}
        <Route
          path="/login"
          element={
            <IsLoggedIn>
              <Login />
            </IsLoggedIn>
          }
        />
        <Route
          path="/"
          element={
            <IsAuth>
              <ProtectedRoute>
                <SideNav>
                  <MainLayout />
                </SideNav>
              </ProtectedRoute>
            </IsAuth>
          }
          errorElement={<Wrong />}
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="admin/company-info" element={<CompanyInfo />} />
          <Route path="admin/outlet" element={<Outlets />} />
          <Route path="admin/users" element={<Users />} />
          <Route path="admin/roles" element={<Roles />} />
          {/* wallet transfer */}
          <Route path="admin/walletTransfer" element={<WalletTransfer />} />
          <Route
            path="warehouse/walletTransfer"
            element={<WhWalletTransfer />}
          />
          <Route path="master/head" element={<Head />} />
          <Route path="master/account" element={<AccountMaster />} />
          <Route path="master/SubAccount" element={<SubAccountMaster />} />
          <Route path="master/customers" element={<Customers />} />
          <Route path="master/main-category" element={<MainCategory />} />
          <Route path="master/sub-category" element={<SubCategory />} />
          <Route path="master/product" element={<Product />} />
          <Route path="master/salesman" element={<SalesMan />} />
          <Route path="master/type-design" element={<TypeDesign />} />
          <Route path="master/uom" element={<Uom />} />
          <Route path="master/warehouse" element={<WareHouse />} />
          <Route path="master/loyality" element={<Loyality />} />
          <Route path="master/paymentType" element={<PaymentType />} />
          <Route path="master/memberlist" element={<MemberList />} />
          <Route path="outlets/cashClose" element={<CashClose />} />
          <Route path="outlets/expensesClose" element={<ExpensesClose />} />

          {/* menu */}
          <Route path="admin/mainMenu" element={<MainMenu />} />
          <Route path="admin/subMenu" element={<SubMenu />} />
          <Route
            path="admin/menuAuthorization"
            element={<MenuAuthorization />}
          />
          <Route path="admin/transaction-provider" element={<TransactionProvider />} />

          {/* warehouse */}
          <Route
            path="warehouse/receipts"
            element={
              <IsAuth>
                <Receipts />
              </IsAuth>
            }
          />
          <Route
            path="warehouse/damage-approve"
            element={
              <IsAuth>
                <Whdamageapproval />
              </IsAuth>
            }
          />
          <Route
            path="warehouse/purchase-return-approve"
            element={
              <IsAuth>
                <PurchaseReturnApprovel />
              </IsAuth>
            }
          />
          <Route
            path="warehouse/payment"
            element={
              <IsAuth>
                <Payment />
              </IsAuth>
            }
          />
          <Route
            path="warehouse/wastage"
            element={
              <IsAuth>
                <Wastage />
              </IsAuth>
            }
          />
          <Route
            path="warehouse/closeing-stock"
            element={
              <IsAuth>
                <CloseStock />
              </IsAuth>
            }
          />
          <Route
            path="warehouse/closeing-stock/pendingstock"
            element={
              <IsAuth>
                <CloseStockWhPending />
              </IsAuth>
            }
          />
          <Route
            path="outlet/closeing-stock/pendingstock"
            element={
              <IsAuth>
                <CloseStockOtPending />
              </IsAuth>
            }
          />
          <Route
            path="warehouse/expenses"
            element={
              <IsAuth>
                <DummyWh />
              </IsAuth>
            }
          />
          <Route
            path="warehouse/purchaseQR"
            element={
              <IsAuth>
                <PurchaseQR />
              </IsAuth>
            }
          />
          <Route
            path="warehouse/barcode"
            element={
              <IsAuth>
                <BarCode />
              </IsAuth>
            }
          />
          <Route
            path="warehouse/barcode-discount"
            element={
              <IsAuth>
                <BarcodeDiscount />
              </IsAuth>
            }
          />
          <Route
            path="warehouse/whCashClose"
            element={
              <IsAuth>
                <WhCashClose />
              </IsAuth>
            }
          />
          <Route
            path="warehouse/whExpensesClose"
            element={
              <IsAuth>
                <WhExpensesClose />
              </IsAuth>
            }
          />
          <Route
            path="warehouse/transfer-request"
            element={
              <IsAuth>
                <TransferRequest />
              </IsAuth>
            }
          />
          <Route
            path="warehouse/warehouse-transfer-report"
            element={
              <IsAuth>
                <WarehouseTransferReport />
              </IsAuth>
            }
          />

          {/* outlets */}

          <Route
            path="outlets/closeStocks"
            element={
              <IsAuth>
                <ClosingStockExpense />
              </IsAuth>
            }
          />
          <Route
            path="outlets/expense"
            element={
              <IsAuth>
                <Expense />
              </IsAuth>
            }
          />
          <Route
            path="outlets/wastages"
            element={
              <IsAuth>
                <Wastages />
              </IsAuth>
            }
          />
          <Route
            path="outlets/barcodeEntry"
            element={
              <IsAuth>
                <BarcodeEntry />
              </IsAuth>
            }
          />
          <Route
            path="outlets/ot-to-ot-transfer"
            element={
              <IsAuth>
                <OtToOtTransfer />
              </IsAuth>
            }
          />
          <Route
            path="outlets/phonePayLogs"
            element={
              <IsAuth>
                <PhonePayLogs />
              </IsAuth>
            }
          />
          <Route
            path="outlets/phonePayEnquiry"
            element={
              <IsAuth>
                <PhonePayEnquiry />
              </IsAuth>
            }
          />

          {/* Reports */}
          <Route path="reports/products" element={<Products />} />
          <Route path="reports/gstReport" element={<GstReport />} />
          <Route path="reports/purchase" element={<PurchaseReport />} />
          <Route
            path="reports/purchase-return"
            element={<PurchaseReturnReport />}
          />
          <Route path="reports/payment" element={<PaymentReports />} />
          <Route path="reports/expenses" element={<ExpensesReport />} />
          <Route path="reports/outletexpenses" element={<OutletExpenses />} />
          <Route
            path="reports/sales-performance"
            element={<Salesperformance />}
          />
          <Route
            path="reports/wh-wallet-transferreport"
            element={<WhWalletReport />}
          />
          <Route
            path="reports/outlet-wallet-transferreport"
            element={<WalletReport />}
          />
          <Route
            path="reports/salestransfer-report"
            element={<SalestransferReport />}
          />
          <Route path="reports/barcode-history" element={<BarcodeHistory />} />
          <Route
            path="reports/barcode-history-outlet"
            element={<BarcodeForm />}
          />
          <Route
            path="reports/barcode-audit-history"
            element={<BarcodeAuditHistory />}
          />
          <Route
            path="reports/product-grn-report"
            element={<ProductGrnReport />}
          />

          <Route path="reports/receipts" element={<ReceiptReports />} />
          <Route path="reports/salesManReport" element={<SalesManReport />} />
          <Route
            path="reports/outlet-salesManReport"
            element={<OutletSalesManReport />}
          />
          <Route path="reports/hsnReport" element={<HsnReport />} />
          <Route path="reports/itemWiseReport" element={<ItemReport />} />
          <Route path="reports/salesReport" element={<SalesReport />} />
          <Route
            path="reports/salesReturnReport"
            element={<SalesReturnReport />}
          />
          <Route path="reports/wh-allItemWise" element={<WhAllItemWise />} />
          <Route path="reports/wh-groupWisemWise" element={<WhGroupWise />} />

          {/* outletSales report */}
          <Route
            path="reports/outletSalesReport"
            element={<OutletSalesReport />}
          />
          <Route
            path="reports/customerSalesReport"
            element={<CustomerWiseSalesReport />}
          />
          <Route
            path="reports/outletSalesItemWise"
            element={<OutletItemReport />}
          />
          <Route
            path="reports/closing-stock-unsavedReport"
            element={<OutletunsavedReport />}
          />
          <Route
            path="outlet/stock-unverified"
            element={<OutletStockUnverified />}
          />
          <Route
            path="reports/outletreorderReport"
            element={<OutletReorderReport />}
          />
          <Route
            path="reports/outletindentReport"
            element={<IndentReorderReport />}
          />
          <Route
            path="reports/outletindent-supplierwise-Report"
            element={<IndentSupplierReport />}
          />
          <Route
            path="reports/OutletItemBreakupsReport"
            element={<OutletItemBreakupsReport />}
          />
          <Route path="report/outletGstReport" element={<OutletGstReport />} />
          <Route path="report/outletHsnReport" element={<OutletHsnReport />} />
          <Route path="reports/ot-allItemWise" element={<OtAllItemWise />} />
          <Route path="reports/ot-groupWisemWise" element={<OtGroupWise />} />
          <Route
            path="reports/allSalesManReport"
            element={<AllSalesManReport />}
          />
          <Route
            path="reports/stockMissingReport"
            element={<StockMissingReports />}
          />
          <Route
            path="reports/otSalesReturnReport"
            element={<OtSalesReturn />}
          />
          <Route
            path="reports/otPurchaseReturnReport"
            element={<OtPurchaseReturn />}
          />
          <Route path="reports/otCashClose" element={<OtCashClose />} />
          <Route path="reports/otExpenseClose" element={<OtExpenseClose />} />
          <Route
            path="reports/ot-To-ot-transfer-reports"
            element={<OtTootTransferReports />}
          />
          <Route path="reports/MemberReports" element={<MemberReports />} />
          <Route path="reports/billWiseHsn" element={<BillWiseHsn />} />
          <Route
            path="reports/OtClosingStockReports"
            element={<OtClosingStockReports />}
          />
          <Route
            path="reports/Wh-ClosingStockReports"
            element={<WhClosingStockReports />}
          />
          <Route
            path="reports/OtClosingStock-missing-Reports"
            element={<OtClosingStockMissingReports />}
          />
          <Route
            path="reports/whClosingStock-missing-Reports"
            element={<WhClosingStockMissingReports />}
          />
          <Route
            path="reports/whClosingStock-damage-Reports"
            element={<Whdamagereport />}
          />
          <Route
            path="reports/OverallBranchWiseReport"
            element={<OverallBranchWiseReport />}
          />
          <Route
            path="reports/branchWise-Physical-stock-Report"
            element={<BranchWisePhysicalStockReport />}
          />
          <Route
            path="reports/Customer-Walk-Ins-Report"
            element={<CustomerWalkInsReport />}
          />
          <Route
            path="reports/ot-branchcategoryWise"
            element={<OtBranchCategoryWise />}
          />
          <Route path="reports/referrer-report" element={<ReferrerReport/>} />
          <Route path="reports/stockverifyMismatch-report" element={<Stockverificationmismatchreport/>} />
          <Route path="reports/stockverifypending-report" element={<Stockverifypendingreport/>} />
          <Route path="reports/highsalesvendor-report" element={<HighSalesVendorReport/>} />
          <Route path="reports/netprofitsales-report" element={<NetProfitSalesReport/>} />
          {/* ledger */}
          <Route path="ledger/salesLedger" element={<SalesLedger />} />
          <Route path="ledger/purchaseLedger" element={<PurchaseLedger />} />
          <Route path="ledger/stockLedger" element={<StockLedger />} />
          <Route path="ledger/expensesLedger" element={<ExpensesLedger />} />
          <Route
            path="ledger/otExpensesLedger"
            element={<OtExpensesLedger />}
          />
          <Route
            path="ledger/outletSalesLedger"
            element={<OutletSalesLedger />}
          />
          <Route
            path="ledger/outletStockLedger"
            element={<OutletStockLedger />}
          />
          <Route
            path="ledger/allOutletStockLedger"
            element={<AllOutletStockLedger />}
          />
          <Route
            path="reports/stockValuereport"
            element={<StockValueReport />}
          />
          <Route
            path="reports/Wh-expense-close-report"
            element={<WhExpenseCloseReport />}
          />
          <Route
            path="outlet/purchase-return"
            element={<PurchaseReturns />}
            errorElement={<Wrong />}
          />
        </Route>
        <Route
          path="warehouse/purchase"
          element={
            <IsAuth>
              <ProtectedRoute>
                <Purchase />
              </ProtectedRoute>
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        <Route
          path="warehouse/purchase-return"
          element={
            <IsAuth>
              <ProtectedRoute>
                <PurchaseReturn />
              </ProtectedRoute>
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        <Route
          path="warehouse/sales-or-issue"
          element={
            <IsAuth>
              <ProtectedRoute>
                <SalesOrIssue />
              </ProtectedRoute>
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        <Route
          path="warehouse/sales-return"
          element={
            <IsAuth>
              <ProtectedRoute>
                <SalesReturn />
              </ProtectedRoute>
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        {/* outlets */}
        <Route
          path="outlets/stockVerify"
          element={
            <IsAuth>
              <ProtectedRoute>
                <StockVerify />
              </ProtectedRoute>
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        <Route
          path="outlets/stockVerify-barcode"
          element={
            <IsAuth>
              <ProtectedRoute>
                <StockVerifiactionBarcode />
              </ProtectedRoute>
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        <Route
          path="outlets/sales"
          element={
            <IsAuth>
              <ProtectedRoute>
                <Sales />
              </ProtectedRoute>
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        <Route
          path="outlets/salesReturns"
          element={
            <IsAuth>
              <ProtectedRoute>
                <SalesReturns />
              </ProtectedRoute>
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        <Route
          path="outlets/indent"
          element={
            <IsAuth>
              <ProtectedRoute>
                <SalesReorder />
              </ProtectedRoute>
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        <Route
          path="invoice/:id"
          element={
            <IsAuth>
              <ProtectedRoute>
                <Invoice />
              </ProtectedRoute>
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        <Route
          path="invoices/:id"
          element={
            <IsAuth>
              <ProtectedRoute>
                <Invoices />
              </ProtectedRoute>
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        <Route
          path="invoiceReport/:id"
          element={
            <IsAuth>
              <ProtectedRoute>
                <InvoiceReport />
              </ProtectedRoute>
            </IsAuth>
          }
          errorElement={<Wrong />}
        />

        <Route
          path="productData/:id"
          element={
            <IsAuth>
              <ProtectedRoute>
                <ProductPdf />
              </ProtectedRoute>
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        <Route
          path="otTransfer/:id"
          element={
            <IsAuth>
              <TransferPdf />
            </IsAuth>
          }
          errorElement={<Wrong />}
        />

        <Route
          path="sales/:id"
          element={
            <IsAuth>
              <ThermalPrint />
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        <Route
          path="cashClose/:id"
          element={
            <IsAuth>
              <CashCloseThemal />
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        <Route
          path="expenseClose/:id"
          element={
            <IsAuth>
              <ExpenseCloseThermal />
            </IsAuth>
          }
          errorElement={<Wrong />}
        />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Routers;
